import * as React from 'react';
import { Form } from './components/Form';
import { getSettings } from '@app/src/configuration/config.service';
import { validateTokenMfa } from '@app/src/utils/validations';
import { Redirect } from 'react-router-dom';

export const LoginMfa = ({ history }) => {

  //sessionStorage.clear();

  const isValid = validateTokenMfa();
  if (!isValid) {
    return <Redirect to="/" />
  }
  return(
    <Form
      history={history}
      urlVerification={getSettings().API_VERIFICATION_OTP}
      urlResendOtp={getSettings().API_RESEND_OTP}
    />
  );
};

